import Vue from "vue";
import Locales from "@/utils/locales";
import countries from "@/models/country.json";
import i18n from "@/config/i18n";

Vue.filter("toCurrency", function (value: number) {
    if (isNaN(value) || value === null || value === undefined) {
        return null;
    }

    const localeCode = Locales.getLocaleCode().replace('_', "-");

    const currencyFormatter = new Intl.NumberFormat(
      localeCode,
      {
          style: "currency",
          currency: "EUR"
      }
    );
    const currencyFormatterOptions = currencyFormatter.resolvedOptions();
    const currencyFractionsDigits = currencyFormatterOptions.maximumFractionDigits;

    const valueFormatter = new Intl.NumberFormat(
      localeCode,
      {
          minimumFractionDigits: currencyFractionsDigits,
          maximumFractionDigits: currencyFractionsDigits
      }
    );

    const formattedValue = valueFormatter.format(value);

    const integerPart = formattedValue.substring(0, formattedValue.length - (currencyFractionsDigits+1));
    const integerPartHtml = integerPart;

    const decimalPart = formattedValue.substring(integerPart.length);
    const decimalPartHtml = `<span class='cent'>${decimalPart}</span>`;

    const currencyPlaceholder = currencyFormatter.format(NaN);

    const currencyPart = currencyPlaceholder.replace('NaN', '');
    const currencyPartHtml = `<span class='currency'>${currencyPart}</span>`;

    const numberPosition = currencyPlaceholder.indexOf('NaN');
    if (numberPosition === 0) {
        return `${integerPartHtml}${decimalPartHtml}${currencyPartHtml}`;
    }

    return `${currencyPartHtml}${integerPartHtml}${decimalPartHtml}`;
});

Vue.filter("toCurrencyHT", function (value: number) {
    if (isNaN(value) || value === null || value === undefined) {
        return null;
    }

    return `${Vue.filter("toCurrency")(value)}<span class='tax'> ${i18n.t('config.taxMode.taxFree')}</span>`;
});

Vue.filter("toCurrencyTTC", function (value: number) {
    if (isNaN(value) || value === null || value === undefined) {
        return null;
    }

    const integerPart = Math.trunc(value);
    const decimalPart = (value % 1).toFixed(2).substring(2);

    if (Locales.getLocaleCode() === "fr_FR") {
        return integerPart + "<span class='cent'>," + decimalPart + "</span> €<span class='tax'> TTC</span> ";
    } else {
        return "€" + integerPart + "<span class='cent'>." + decimalPart + "</span> <span class='tax'> Incl tax</span>";
    }
});

Vue.filter("shortDate", function (date) {
    if (date) {
        return new Date(date).toLocaleDateString();
    }
});

Vue.filter("toInt", function (qty) {
    if (qty) {
        return +qty;
        //return Math.round(qty);
    }
});

Vue.filter("longDate", function (date) {
    if (date) {
        return new Intl.DateTimeFormat("fr-FR", {
            year: "numeric",
            month: "long",
            day: "numeric",
        }).format(new Date(date));
    }
});

Vue.filter("convertTimestamp", function (timestamp) {
    return new Date(timestamp * 1000).toLocaleDateString();
});

Vue.filter("toCountryName", function (value) {
    return countries.filter(country => country.code === value)[0]['label_' + i18n.locale]

});
